import script from "./esTimeslotForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./esTimeslotForm.vue?vue&type=script&setup=true&lang=ts"

import "./esTimeslotForm.vue?vue&type=style&index=0&id=48045614&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48045614"]])

export default __exports__